import React from "react";

export default function EducationTab() {
  return (
    <div
      className="row"
      id="educationTab"
      data-aos="fade-in"
      data-aos-easing="linear"
      data-aos-delay="0"
      data-aos-duration="500"
    >
      <div className="col-12 col-lg-6">
        <div className="content">
          <span className="subtitle my-1 text-start">2013 - 2022</span>
          <h4 className="title my-0 text-start">Education Profile</h4>
          <div className="list">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Post Graduation</h4>
                      <span>Himalyan Gharwal University (2020 - 2022)</span>
                    </div>
                    <div className="percentage">
                      <span>86%</span>
                    </div>
                  </div>
                  <p className="card-text">
                    I completed my Master of Computer Application (MCA) degree
                    from Himalyan Gharwal University. The duration of the
                    program was from 2020 to 2022. During my master's studies, I
                    gained a comprehensive understanding of various concepts and
                    technologies related to computer science and engineering.
                    The program equipped me with the necessary skills to analyze
                    problems, design solutions, and develop software
                    applications. It also provided me with a strong foundation
                    in programming languages, algorithms, database management,
                    and other relevant subjects.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Graduation</h4>
                      <span>Kurukshetra University (2015 - 2019)</span>
                    </div>
                    <div className="percentage">
                      <span>61%</span>
                    </div>
                  </div>
                  <p className="card-text">
                    I completed my Bachelor of Science (Bsc IT) degree in
                    Information Technologies (IT) from Kurukshetra University.
                    The duration of the program was from 2015 to 2019. During my
                    undergraduate studies, I gained a comprehensive
                    understanding of various concepts and technologies related
                    to computer science and engineering. The program equipped me
                    with the necessary skills to analyze problems, design
                    solutions, and develop software applications. It also
                    provided me with a strong foundation in programming
                    languages, algorithms, database management, and other
                    relevant subjects.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Intermediate</h4>
                      <span>Guru Nanak Inter college (2014 - 2015)</span>
                    </div>
                    <div className="percentage">
                      <span>62%</span>
                    </div>
                  </div>
                  <p className="card-text">
                    I pursued my intermediate education from the Guru Nanak
                    Inter college. I completed my 12th grade with a
                    specialization in Physics, Chemistry, and Mathematics (PCM)
                    during the academic year 2014-15. This stage of my education
                    allowed me to delve deeper into the core subjects of science
                    and mathematics. It helped me develop analytical thinking,
                    problem-solving skills, and a solid understanding of the
                    fundamental concepts in these fields.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Matriculate</h4>
                      <span>Guru Nanak Inter college (2012 - 2013)</span>
                    </div>
                    <div className="percentage">
                      <span>74%</span>
                    </div>
                  </div>
                  <p className="card-text">
                    My secondary education was completed under the Guru Nanak
                    Inter college. I successfully completed my 10th grade during
                    the academic year 2012-13. This phase of my education
                    provided me with a well-rounded understanding of various
                    subjects, including Mathematics, Science, Hindi, English,
                    and Social Science. It laid the groundwork for my future
                    academic pursuits and instilled in me a sense of discipline,
                    time management, and effective study habits.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-6 mt-5 mt-lg-0">
        <div className="content">
          <span className="subtitle my-1 text-start">2022 - 2023</span>
          <h4 className="title my-0 text-start">Certification Profile</h4>
          <div className="list">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Selenium (Basic)</h4>
                      <span>Great Learning (2025)</span>
                    </div>
                    <div className="view-certificate">
                      <span>
                        <a
                          href="https://www.mygreatlearning.com/certificate/GEEMNVCM"
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Certificate
                        </a>
                      </span>
                    </div>
                  </div>
                  <p className="card-text">
                  It covers Selenium WebDriver setup, locating elements using XPath and CSS Selectors, automating 
                  browser actions like form filling and navigation, handling alerts, frames, and windows, 
                  using waits for synchronization, writing test scripts in Java, and integrating with TestNG for 
                  test execution and reporting. Includes hands-on practice with real-world scenarios to build a 
                  strong foundation in automation testing.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>Java (Basic)</h4>
                      <span>HackerRank (2024)</span>
                    </div>
                    <div className="view-certificate">
                      <span>
                        <a
                          href="https://www.hackerrank.com/certificates/d68ee525096a"
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Certificate
                        </a>
                      </span>
                    </div>
                  </div>
                  <p className="card-text">
                    It will cover basic topics in Java language such as classes,
                    data structures, inheritance, exception handling, etc.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>React (Basic)</h4>
                      <span>HackerRank (2023)</span>
                    </div>
                    <div className="view-certificate">
                      <span>
                        <a
                          href="https://www.hackerrank.com/certificates/42a479151608"
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Certificate
                        </a>
                      </span>
                    </div>
                  </div>
                  <p className="card-text">
                    React (Basic) It covers topics like Basic Routing, Rendering
                    Elements,State Management (Internal Component State),
                    Handling Events, ES6 and JavaScript and Form Validation.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>JavaScript (Basic)</h4>
                      <span>HackerRank (2024)</span>
                    </div>
                    <div className="view-certificate">
                      <span>
                        <a
                          href="https://www.hackerrank.com/certificates/4a08904937c0"
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Certificate
                        </a>
                      </span>
                    </div>
                  </div>
                  <p className="card-text">
                    It covers topics like, Functions, Currying, Hoisting, Scope,
                    Inheritance, Events and Error Handling.
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>SQL (Basic)</h4>
                      <span>HackerRank (2024)</span>
                    </div>
                    <div className="view-certificate">
                      <span>
                        <a
                          href="https://www.hackerrank.com/certificates/17646695f1bf"
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Certificate
                        </a>
                      </span>
                    </div>
                  </div>
                  <p className="card-text">
                    It includes simple queries, relationships, and aggregators.
                  </p>
                </div>
              </div>

              
              <div className="card">
                <div className="card-body p-0">
                  <div className="heading">
                    <div className="card-title">
                      <h4>CSS</h4>
                      <span>HackerRank (2024)</span>
                    </div>
                    <div className="view-certificate">
                      <span>
                        <a
                          href="https://www.hackerrank.com/certificates/4a9f1efa8500"
                          target="_blank"
                          rel="noreferrer"
                        >
                          View Certificate
                        </a>
                      </span>
                    </div>
                  </div>
                  <p className="card-text">
                    It covers topics like exploring Cascading and Inheritance,
                    exploring text styling fundamentals, understanding the use
                    of layouts in CSS, understand the boxing of elements in CSS,
                    among others.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
